// extracted by mini-css-extract-plugin
export default {"box":"detail_box__PJl+A","subTitle":"detail_subTitle__Ba33R","flexBox":"detail_flexBox__Oq38K","fix":"detail_fix__JK+7n"};